<template>
  <div>
    <!-- 标签 -->
    <div class="logistics-number">
      <div class="text">NO：<span>{{ dataForm.number }}</span></div>
      <div class="time">{{ dataForm.createTime }}</div>
    </div>

    <div class="logisticsInfo">
      <h3>发货信息</h3>
      <el-row>
        <el-col :span="8">送货方式：<span>{{ dataForm.sendTypeDesc }}</span></el-col>
        <!-- 上门自提 -->
        <template v-if="dataForm.sendType === '01'">
          <el-col :span="8">身份证号码：<span>{{ dataForm.idCard }}</span></el-col>
        </template>

        <!-- 物流送货 -->
        <template v-else-if="dataForm.sendType === '02'">
          <el-col :span="8">要求送达时间：<span>{{ dataForm.expectSendDate }} {{ deliveryTimeTypeDesc }} {{ dataForm.deliveryTimeLabel }}</span></el-col>
          <el-col :span="8">签收方式：
            <span v-if="dataForm.deliverySignatureMode == '1'">凭印章收货</span>
            <span v-if="dataForm.deliverySignatureMode == '2'">凭身份证签收</span>
          </el-col>
          <el-col v-if="dataForm.deliverySignatureMode == '2'" :span="8">身份证号码：<span>{{ dataForm.idCard }}</span></el-col>
        </template>

        <!-- 快递送货 -->
        <template v-else-if="dataForm.sendType === '03'">
          <el-col :span="8">付费方式：
            <span v-if="dataForm.payType == '1'">到付</span>
            <span v-if="dataForm.payType == '3'">寄付</span>
          </el-col>
        </template>
      </el-row>

      <template v-if="['01', '02', '03'].includes(dataForm.sendType)">
        <div class="supplierName">
          <div class="supplier">
            收货公司
          </div>
          <p>{{ dataForm.receiveCompanyName }}</p>
        </div>

        <div v-if="dataForm.receiveCompanyName" class="receivingAddress">
          <ab-svg name="dingwei"></ab-svg>
          {{ dataForm.receiveAddress }}/{{ dataForm.receiveLink }}/{{ dataForm.receivePhone }}
        </div>

        <el-alert
          v-if="dataForm.remark"
          :title="'备注：' + dataForm.remark"
          type="warning"
          :closable="false"
        />
      </template>
    </div>

    <div class="goodsInfo">
      <h3>货物信息</h3>

      <ab-table
        stripe
        class="materialTable"
        ref="table"
        selectionWidth="45"
        indexWidth="50"
        widths="140"
        maxHeight="540"
        :column-list="columns"
        :table-list="dataForm.entry"
        :headerCellClassName="headerCellClassName"
      ></ab-table>

      <el-row>
        <el-col :span="6">
          <span>总数量</span>
          <div class="number">{{ dataForm.count }}</div>
        </el-col>
        <el-col :span="6">
          <span>总件数</span>
          <div class="number">{{ dataForm.piece }}</div>
        </el-col>
        <el-col :span="6">
          <span>总毛重（kg）</span>
          <div class="number">{{ dataForm.grossWeight }}</div>
        </el-col>
        <el-col :span="6">
          <span>总卡板数</span>
          <div class="number">{{ dataForm.cardBoard }}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'logistics-detail-view',
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    },

    dataForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data() {
    return {
      columns: [
        {
          props: 'clientNumber',
          labels: '订单编号',
          widths: 160
        },
        {
          props: 'model',
          labels: '型号',
          widths: 140
        },
        {
          props: 'brand',
          labels: '品牌',
          widths: 140
        },
        {
          props: 'declareGoodsName',
          labels: '品名',
          widths: 140
        },
        {
          props: 'originPlaceIdDesc',
          labels: '产地',
          widths: 140
        },
        {
          props: 'qty',
          labels: '订单数量',
          widths: 100
        },
        {
          props: 'canDeliveredQty',
          labels: '可发数量',
          widths: 100
        },
        {
          props: 'unitName',
          labels: '单位',
          widths: 100
        },
        {
          props: 'sendQty',
          labels: '本次数量',
          widths: 100
        },
        {
          props: 'piece',
          labels: '件数',
          widths: 100
        },
        {
          props: 'grossWeight',
          labels: '毛重(kg)',
          widths: 100
        },
        {
          props: 'cardBoard',
          labels: '卡板数',
          widths: 100
        },
        {
          props: 'custMatNo',
          labels: '料号',
          widths: 140
        },
        {
          props: 'custOrderNo',
          labels: '我司单号',
          widths: 160
        }
      ]
    }
  },

  computed: {
    deliveryTimeTypeDesc() {
      let desc = ''
      switch(this.dataForm.deliveryTimeType) {
        case '01':
          desc = '上午'
          break
        case '02':
          desc = '下午'
          break
        case '03':
          desc = '指定时间'
          break
      }
      return desc
    }
  },

  mounted() {
    
  },

  methods: {
    headerCellClassName({ row, column, rowIndex, columnIndex }) {
      if (['sendQty', 'piece', 'grossWeight'].includes(column.property)) {
        return 'must'
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
</style>
